import React, { useState, useEffect,Suspense, lazy  } from "react";
import { Topbox,Footer2,NewsBox } from "../../components";
import { useParams } from "react-router-dom";
import { axiosReq } from "../../commons/axiosReq";
import Cookies from 'universal-cookie';
const BottomNewses2 = lazy(() => import('../../components/User/MainLayout2/BottomNewses2'));

const SingleNews = () =>{
   const [data, setData] = useState();
   const [similar, setSimilar] = useState();
    const [search, setSearch] = useState("");
     const [reCheck, setRecheck] = useState(false);
     const params = useParams().id;

       const cookies = new Cookies();
       
      window.addEventListener('load',async () => {
           console.log('mofid 1');
           console.log(cookies.get('viewCounted') );
     
           // Check if the view has already been counted today using a cookie
           if (await cookies.get('viewCounted') != true) { 
             console.log('mofid 2');
               // Call the API to increment the view count
              const dataUser=await axiosReq("Admins/increment", "get")
              console.log(333333)
              console.log(dataUser)
     
               if (dataUser==true) {
                 console.log(5555)
     
                 // Set a cookie to indicate the view has been counted (expires in 24 hours)
                 const date = new Date();
                 date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); // 24 hours
            await  cookies.set('viewCounted', 'true', { path: '/', expires: date });
                   }
           }
       });
   
       const GetData = async () => {
            const writersData = await axiosReq("Admins/GetArticlebySlug?slug="+params, "get");
            console.log(writersData)
            setData(writersData)
            const similarData = await axiosReq("Admins/GetSimilarArticlesbySlug?slug="+params, "get");
            console.log(similarData)
            setSimilar(similarData?.data)
        }
        useEffect(() => {
    
            GetData();
        }, [reCheck,search]);
 
    return(
        <>
       <Topbox 
       imgPath={data?.mainPicture} 
       title={data?.articleTittle}
       text={data?.newsBox}
       secondTitle={data?.secondTitle}
       />

       <NewsBox 
       title={data?.articleTittle}
       text={data?.newsText}
       date={data?.datePublished}
       tags={data?.articleTagTbls}
       link={data?.shortLink}
       />
       <div>
                            <Suspense fallback={<div>Loading...</div>}>
        
       <BottomNewses2 data={similar} params={params}>
        اخبار مرتبط
       </BottomNewses2>
       </Suspense>
       </div>
    
        </>
    )
}
export default SingleNews;